import { combineReducers } from 'redux'

import adminListing from './surveys/adminListing'
import surveyForms from './surveys/surveyForms'
import surveyResults from './surveys/surveyResults'

const surveyReducers = combineReducers({
  surveyForms,
  adminListing,
  surveyResults
})

export default surveyReducers
